import { watch } from 'vue';
import { usePermissions } from '../composables/usePermissions';

export const permissionDirective = {
  mounted(el, binding) {
    const { value, modifiers } = binding;
    const { permissions, hasAnyPermission } = usePermissions();

    if (!value) {
      console.warn('v-permission directive requires a permission string or array');
      return;
    }

    const checkAndApply = () => {
      const requiredPermissions = Array.isArray(value) ? value : [value];
      const isAllowed = hasAnyPermission(requiredPermissions);

      if (!isAllowed) {
        if (modifiers.disable) {
          el.disabled = true;
          el.style.opacity = '0.5';
          el.style.cursor = 'not-allowed';
          el.classList.add('unauthorized-disabled');
        } else {
          el.style.display = 'none';
        }
      } else {
        if (modifiers.disable) {
          el.disabled = false;
          el.style.opacity = '';
          el.style.cursor = '';
          el.classList.remove('unauthorized-disabled');
        } else {
          el.style.display = '';
        }
      }
    };

    // Initial check
    checkAndApply();

    // Watch for permission changes
    const unwatch = watch(
      () => permissions.value,
      () => {
        checkAndApply();
      },
      { deep: true }
    );

    // Store unwatch function on the element for cleanup
    el.__permissionUnwatch__ = unwatch;
  },

  unmounted(el) {
    // Cleanup watcher
    if (el.__permissionUnwatch__) {
      el.__permissionUnwatch__();
      delete el.__permissionUnwatch__;
    }
  }
};
